import { CopilotServiceApplication } from '@/application/copilot-service-application';

import { EventAggregationService } from "@/utils/event-aggregation-service";
import globals from "@/utils/globals";
import { AuthenticationCompletedEvent } from "@studyportals/authentication-service-interfaces";
import { ISubscriber } from "@studyportals/event-aggregation-service-interface";



export class LoginStatusCheckerPlugin
implements ISubscriber<AuthenticationCompletedEvent> {
	constructor() {

		EventAggregationService.instance?.subscribeTo(
			AuthenticationCompletedEvent.EventType,
			this,
		);

	}

	public async notify(): Promise<void> {
		await this.initiate();
	}

	public async initiate(): Promise<void> {
		const session = await globals.sessionService.getSession();

		const notLoggedIn = session === null;
		if (notLoggedIn) return;

		const user = session.getUser().identityId;
		CopilotServiceApplication.Store.mutations.setUserId(user);
	}
}
